export default __webpack_public_path__ + "media/715f23268da9a3c5bbd24191b8e1b1e35da8ef7433f0f3ead57d466439e8d913.svg";